import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { HttpService } from '../../services/http.service';
import { CustomToastComponent } from '../toast/custom-toast.component';

interface ApiDataResponse {
    status: boolean;
    message: string;
    data: {
        status: string; // "APPROVED", "REJECTED", or "ALREADY_APPROVED"
    };
}

@Component({
    selector: 'app-approve-onboarding',
    templateUrl: './approve-onboarding.component.html',
    styleUrls: ['./approve-onboarding.component.scss'],
    imports: [
        ReactiveFormsModule,
        CommonModule,
        FormsModule,
    ],
})
export class ApproveOnboardingComponent implements OnInit, OnDestroy {
    private readonly destroy$ = new Subject<void>();



    constructor(
        private httpService: HttpService,
        private snackBar: MatSnackBar,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {

    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private showSuccessToast(message: string): void {
        this.showToast(message, 'success-toast');
    }

    private showErrorToast(message: string | null | undefined): void {
        if (!message) return;
        this.showToast(message, 'error-toast');
    }

    private showToast(message: string, panelClass: string): void {
        this.snackBar.openFromComponent(CustomToastComponent, {
            data: { message },
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['no-padding-snackbar', panelClass]
        });
    }
}